'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var moment = require('moment-timezone');

var ProductCardController = function () {
  function ProductCardController() {
    _classCallCheck(this, ProductCardController);

    this.errorChecking();
  }

  _createClass(ProductCardController, [{
    key: 'errorChecking',
    value: function errorChecking() {
      if (!this.product) {
        console.log('PRODUCT_CARD_ERROR: product prop must be provided by parent.');
      }
    }
  }, {
    key: 'getDateString',
    value: function getDateString(date) {
      return moment(date).format('MM-DD-YY');
    }
  }, {
    key: 'isProductRetired',
    value: function isProductRetired() {
      return moment(this.product.retirementDate).tz(this.feis.get('tz')).endOf('day') < moment(new Date()).tz(this.feis.get('tz'));
    }
  }]);

  return ProductCardController;
}();

exports.default = ProductCardController;


//////////////////
// WEBPACK FOOTER
// ./product-list/product-card/index.js
// module id = 498
// module chunks = 0